/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable max-len */
/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable class-methods-use-this */
import BaseService, {
    CATEGORY_PORTAL,
    ERROR_MESSAGE_TOKEN_INVALID,
    ERROR_MESSAGE_UNEXPECTED,
    HTTP_STATUS_BAD_REQUEST,
    HTTP_STATUS_FORBIDDEN,
    HTTP_STATUS_NO_CONTENT,
    HTTP_STATUS_OK,
    HTTP_STATUS_UNAUTHORIZED,
} from "./core/BaseService";

export interface StayMealDateListItem {
    executionDate?: string;
    stayFlg?: string;
    mealMorningFlg?: string;
    mealAfternoonFlg?: string;
    mealEveningFlg?: string;
}

export interface StayMealDataItem {
    comment?: string;
    sexFlg?: string;
    smokingFlg?: string;
    stayMealDateList?: StayMealDateListItem[];
}

export interface AppliesItem {
    careerId: string;
    classId?: string;
    approverId1?: string;
    approverId2?: string;
    approverId4?: string;
    cancelWaitFlg?: boolean;
    stayMealData?: StayMealDataItem[];
}

export interface ApplyPayload {
    careerType?: number;
    reason?: string;
    applies: AppliesItem[];
}

const ERROR_MESSAGE_CAPACITY_OVER = "クラスは満席のため、受講申請できませんでした。";

class ApplyService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "apply");
    }

    public async apply(payload: ApplyPayload, resolved: () => void, rejected: (error: any) => void) {
        await super.postJSON(payload, resolved, rejected);
    }

    protected async errorHandler(response: Response): Promise<Response> {
        const { status } = response;
        if (response.ok && (status === HTTP_STATUS_OK || status === HTTP_STATUS_NO_CONTENT)) {
            return response;
        }

        const json = await response.json();
        switch (status) {
            case HTTP_STATUS_UNAUTHORIZED:
            case HTTP_STATUS_FORBIDDEN:
                throw Error(ERROR_MESSAGE_TOKEN_INVALID);

            case HTTP_STATUS_BAD_REQUEST:
                let message = "";

                const errors = (json.errors || []) as object[];
                const capacityOver = errors.some((error: any) => ApplyService.isCapacityOverError(error.detail as string));
                if (capacityOver) {
                    message = errors.map((e: any) => `${e.detail}`).join("<br/>");
                } else {
                    message = errors.map((e: any) => `${e.item}: ${e.detail}`).join("\n");
                }
                throw Error(message);

            default:
                throw Error(ERROR_MESSAGE_UNEXPECTED);
        }
    }

    public static isCapacityOverError(message: string) {
        return (message || "").includes(ERROR_MESSAGE_CAPACITY_OVER);
    }
}

export default ApplyService;
